import { Icon } from "../../icons";
import { showToast } from "../atoms/toast";
import { openAlert } from "./dialog-helper";

export async function copyToClipboard(
	text: string,
	{ message, icon, id, files }: { message?: string; icon?: Icon; id?: string; files?: File[] } = {}
) {
	// Stop if there is nothing to copy
	if (text.length === 0 && !files?.length) {
		return;
	}

	try {
		if (text?.length) {
			await navigator.clipboard.writeText(text);
		} else if (files?.length && "write" in navigator.clipboard) {
			try {
				// Only support for one clipboard item is supported at the moment and only pngs are supported
				// TODO: Maybe write images to canvas and grab it as png
				const firstFile = files[0];
				await navigator.clipboard.write([
					new ClipboardItem({
						[firstFile.type]: firstFile
					})
				]);
			} catch (err) {
				console.error(err);
				openAlert(`The file could not be copied to your clipboard because the filetype is not supported.`);
				return;
			}
		}
	} catch (err) {
		try {
			// https://stackoverflow.com/questions/73552314/how-can-i-get-clipboard-permission-in-teams-add-on-app
			const $input = document.createElement("input");
			$input.style.position = "fixed";
			$input.style.top = "-1000px";
			$input.style.left = "-1000px";
			$input.value = text;
			document.body.appendChild($input);
			$input.focus();
			$input.select();
			document.execCommand("copy");
			$input.remove();
		} catch (err) {
			console.error(err);
			openAlert(`Something went wrong and the text "${text}" could not be copied to your clipboard.`);
			return;
		}
	}

	// If we get here we have successfully copied the text to the clipboard
	if (message != null) {
		showToast(message, { icon, id });
	}
}

export async function readTextFromClipboard(): Promise<string> {
	try {
		return await navigator.clipboard.readText();
	} catch (err) {
		return "";
	}
}
